// Compares the Cognito permission groups currently held in the session against the
// groups in a freshly minted ID token. Used by the account-menu Permissions modal to
// decide whether a refresh can apply immediately (additions only) or needs an explicit
// confirmation (removals can hard-redirect the user off a ProtectedRoute).
// https://github.com/gobranch/branch/issues/31758
export function diffPermissionGroups(currentGroups, newGroups) {
  return {
    added: newGroups.filter((group) => !currentGroups.includes(group)),
    removed: currentGroups.filter((group) => !newGroups.includes(group))
  };
}
